import React from 'react'
import StatusBadge from 'shared/badges/status-badge'
import { ListGroup } from 'react-bootstrap'
import { useCreateDashboardEmployee } from 'api/hooks/use-dashboard-employees'
import { useQueryClient } from 'react-query'
import {
  faUserSlash
} from '@fortawesome/free-solid-svg-icons'

function EmployeeItem({ employee, params, dashboardId, addOrRemoveEmployee, columnName, onEmployeeCreated, allEmployees, canEdit = true }) {
  const queryClient = useQueryClient()
  const queryParams = {
    employee_id: employee.id,
    dashboard_id: params.dashboardId,
    options: employee.options || 'include',
    database_column_name: employee.database_column_name || columnName
  }
  const { mutate } = useCreateDashboardEmployee({
    params: queryParams,
    options: {
      onSuccess: (data) => {
        if (onEmployeeCreated) {
          onEmployeeCreated(employee, data.id, columnName)
        }
        queryClient.invalidateQueries(`dashboards/${dashboardId}`)
        queryClient.invalidateQueries('dashboards')
      }
    }
  })

  const isSelected = allEmployees.some(emp => emp.id === employee.id && (!columnName || emp.database_column_name === columnName))

  return (
    <ListGroup.Item
      action={canEdit}
      key={`employee-option-${employee.id}`}
      active={isSelected}
      className={isSelected ? 'py-2 bg-light' : 'py-2'}
      onClick={() => {
        if (!canEdit) return
        if (!isSelected) {
          // Stage employee if dashboard doesn't exist yet, otherwise create via API
          if (!params.dashboardId) {
            addOrRemoveEmployee(employee, null, columnName)
          } else {
            mutate()
          }
        } else {
          // Remove employee (staged or existing)
          addOrRemoveEmployee(employee)
        }
      }}
      style={!canEdit ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
    >
      {employee.display_name}
      {employee.status === 'inactive' ? (
        <span className="ms-2">
          <StatusBadge
            title="Disabled"
            icon={faUserSlash}
            tooltipText="No longer an active employee"
          />
        </span>
      ) : null}
    </ListGroup.Item>
  )
}

export default EmployeeItem